// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__sUk2U","center":"Loading_center__LtHIi","wave":"Loading_wave__00YKc"};